import Configurator from "./configurator";

declare global {
	// @ts-ignore
	const esoul_konfigurator_params : {
		ajaxUrl: string,
		nonce: string,
	}
}

window.addEventListener('load', () => {
	const configuratorDom = document.getElementById('configurator-old') as HTMLDivElement;
	if (configuratorDom) {
		const configurator = new Configurator(configuratorDom);
		configurator.init();
	}
});
